<mat-card appearance="outlined">
    <form tabindex="0" class="fix-editor">
        <mat-form-field class="ag-row fix-mat-form">
    <input #dateInput matInput tabindex="0" [type]="_inputType"
           [formControl]="formControl"
           [errorStateMatcher]="matcher"
           dateMask
           [maskOptions]="maskConfigOptions"
           >
            <mat-error *ngIf="formControl.hasError('required')">
                {{ 'se-ui-datagrid_required_value_constraint' | translate }}
            </mat-error>
        </mat-form-field>
    </form>
</mat-card>
